import ExcelJS from "exceljs"
import { saveAs } from "file-saver"

export async function exportToExcel(
	data,
	headerMap,
	fileName = "report.xlsx",
	dateTimeColsException = [],
	hasElementId = false,
	columnsToSum = []
) {
	const workbook = new ExcelJS.Workbook()
	const worksheet = workbook.addWorksheet("Report")
	const keys = Object.keys(headerMap)

	// Define Columns with auto width calculation
	worksheet.columns = keys.map((key) => {
		const headerText = headerMap[key] || key
		let maxLen = headerText.toString().length
		data.forEach((row) => {
			const cellVal = row[key] != null ? row[key].toString() : ""
			if (cellVal.length > maxLen) {
				maxLen = cellVal.length
			}
		})
		return {
			header: headerText,
			key,
			width: Math.min(Math.max(maxLen + 4, 15), 35),
		}
	})

	const isoRegex = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}\.\d{3}Z$/

	// Add Data Rows
	data.forEach((rawRow, rowIndex) => {
		const row = { ...rawRow }
		keys.forEach((key, idx) => {
			const val = rawRow[key]
			if (typeof val === "string" && isoRegex.test(val)) {
				if (dateTimeColsException.includes(idx)) {
					row[key] = new Date(val).toLocaleDateString("en-GB")
				} else {
					row[key] = new Date(val).toLocaleString("en-GB")
				}
			} else if (key === "payment_id" || key === "loan_id" || key === "group_code" || key === "branch_id") {
				row[key] = val != null ? String(val) : ""
			}
		})

		const addedRow = worksheet.addRow(row)
		addedRow.height = 22

		const isTotalRow = rawRow["payment_date"] === "TOTAL" || rawRow["credit"] === "TOTAL" || rawRow["group_name"] === "TOTAL"

		keys.forEach((key) => {
			const cell = addedRow.getCell(key)
			cell.alignment = { vertical: "middle", horizontal: "center", wrapText: true }

			if (isTotalRow) {
				cell.font = { name: "Calibri", size: 11, bold: true, color: { argb: "0F172A" } }
				cell.fill = {
					type: "pattern",
					pattern: "solid",
					fgColor: { argb: "E2E8F0" },
				}
				cell.border = {
					top: { style: "thin", color: { argb: "94A3B8" } },
					bottom: { style: "double", color: { argb: "0F172A" } },
				}
			} else {
				cell.font = { name: "Calibri", size: 10, color: { argb: "1E293B" } }
				cell.border = {
					top: { style: "thin", color: { argb: "E2E8F0" } },
					bottom: { style: "thin", color: { argb: "E2E8F0" } },
					left: { style: "thin", color: { argb: "E2E8F0" } },
					right: { style: "thin", color: { argb: "E2E8F0" } },
				}

				if (rowIndex % 2 === 1) {
					cell.fill = {
						type: "pattern",
						pattern: "solid",
						fgColor: { argb: "F8FAFC" },
					}
				}
			}

			if (key === "payment_id" || key === "loan_id" || key === "group_code" || key === "branch_id") {
				cell.numFmt = "@"
				cell.value = cell.value != null ? String(cell.value) : ""
			}
		})
	})

	// Format Header Row (Row 1)
	const headerRow = worksheet.getRow(1)
	headerRow.height = 28
	headerRow.eachCell((cell) => {
		cell.font = { name: "Calibri", size: 11, bold: true, color: { argb: "FFFFFF" } }
		cell.fill = {
			type: "pattern",
			pattern: "solid",
			fgColor: { argb: "1E293B" }, // Solid Dark Slate
		}
		cell.alignment = { vertical: "middle", horizontal: "center", wrapText: true }
		cell.border = {
			bottom: { style: "medium", color: { argb: "0F172A" } },
		}
	})

	// Add Total Row if columnsToSum passed
	if (columnsToSum && columnsToSum.length > 0) {
		const totalRow = {}
		keys.forEach((key, idx) => {
			if (idx === 0) {
				totalRow[key] = "Total"
			} else if (columnsToSum.includes(key)) {
				const sum = data.reduce((acc, row) => {
					const val = parseFloat(row[key])
					return !isNaN(val) ? acc + val : acc
				}, 0)
				totalRow[key] = sum.toFixed(2)
			} else {
				totalRow[key] = ""
			}
		})
		const addedTotalRow = worksheet.addRow(totalRow)
		addedTotalRow.height = 24
		addedTotalRow.eachCell((cell) => {
			cell.font = { name: "Calibri", size: 11, bold: true, color: { argb: "0F172A" } }
			cell.fill = {
				type: "pattern",
				pattern: "solid",
				fgColor: { argb: "E2E8F0" },
			}
			cell.alignment = { vertical: "middle", horizontal: "center" }
			cell.border = {
				top: { style: "thin", color: { argb: "94A3B8" } },
				bottom: { style: "double", color: { argb: "0F172A" } },
			}
		})
	}

	const buffer = await workbook.xlsx.writeBuffer()
	saveAs(new Blob([buffer]), fileName)
}
